export default __webpack_public_path__ + "static/media/Home_banner.11f7adfb.png";